if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback () {
      if (EmblaCarousel) {
        this.initCarousel()
        this.observeChanges()
      }
    }

    initCarousel () {
      if (this.embla) {
        this.embla.destroy()
      }

      const options = {
        startIndex: 0,
        loop: true,
        axis: 'y',
        slidesToScroll: 1,
      }

      const viewportNode = this.carousel.querySelector('.announcement-bar__viewport')
      this.embla = EmblaCarousel(viewportNode, options)

      this.startAutoplay()

      this.carousel.addEventListener('mouseenter', () => this.stopAutoplay())
      this.carousel.addEventListener('mouseleave', () => this.startAutoplay())
    }

    startAutoplay () {
      this.stopAutoplay()

      this.autoplayInterval = setInterval(() => {
        this.embla.scrollNext()
      }, this.autoplaySpeed)
    }

    stopAutoplay () {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
        this.autoplayInterval = null
      }
    }

    observeChanges () {
      const observer = new MutationObserver(() => {
        this.initCarousel()
      })

      observer.observe(this, {
        childList: true,
        subtree: true,
      })
    }

    get carousel () {
      return this.querySelector('.announcement-bar__carousel')
    }

    get autoplaySpeed () {
      return parseInt(this.dataset.autoplaySpeed, 10) || 500
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)
}
